export default {"src":"/_next/static/media/history_file_black.5ab3421f.svg","height":22,"width":19};